import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPolygon12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPolygon12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Polygon12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m6 .881.299.223 4.532 3.375.279.208-.098.333-1.648 5.626-.105.359H2.742l-.106-.36L.988 5.02l-.097-.333.279-.208 4.532-3.375zM2.046 5.073l1.445 4.932H8.51l1.445-4.932L6 2.128z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Polygon12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconPolygon12);
